import React from "react";
import AppUtils from "@src/utils/appUtils";
import PropTypes from "prop-types";
import { useManagerContext } from "@src/context/managerContext";
import DropDown from "@src/components/atoms/DropDown";
import moment from "moment";

/** Date dropdown for each month since Customer Contract Start */
const MonthlyDateDropDown = () => {
  const { profile, selectedPeriod, setSelectedPeriod } = useManagerContext();

  /** Every selectable month as an array of { text, value } */
  const monthsSinceLaunchDate = () => {
    const start = moment
      .utc(profile.customer.contractStartDate)
      .startOf("month");
    const end = moment.utc().startOf("month");
    const diff = end.diff(start, "months");

    return Array.from({ length: diff + 1 }, (_, i) => {
      const date = start.clone().add(i, "months");
      return {
        text: date.format("MMM, YYYY"),
        value: date.valueOf(),
      };
    });
  };
  const dropdownOptions = [
    { text: "All-Time", value: "all" },
    ...monthsSinceLaunchDate().reverse(),
  ];

  return (
    <DropDown
      options={dropdownOptions}
      value={selectedPeriod}
      onChange={(newValue) => setSelectedPeriod(parseInt(String(newValue)))}
    />
  );
};

export const MonthlyDateDropDownControls = {};

MonthlyDateDropDown.propTypes = AppUtils.getPropTypeFromControls(
  MonthlyDateDropDownControls,
);

export default MonthlyDateDropDown;
